import type { CashierTradingAccountMargin } from "@/api/cashier";
import type { TestDataProps } from "@repo/ui";

export enum TriggerTypes {
  TRANSFER_FROM = "TRANSFER_FROM",
  TRANSFER_TO = "TRANSFER_TO",
}

export type MobileAccountSelectorTriggerProps = {
  selectedAccount?: CashierTradingAccountMargin | null;
  handleTriggerClick: () => void;
} & TestDataProps;
